document.addEventListener('DOMContentLoaded', function () {
  const menuBackdrop = document.getElementById('menu-backdrop');
  if (!menuBackdrop) return;

  document.querySelectorAll('.mega-menu').forEach(function (megaMenu) {
    megaMenu.addEventListener('toggle', function () {
      const isAnyMenuOpen = [...document.querySelectorAll('.mega-menu')].some((menu) =>
        menu.hasAttribute('open')
      );
      menuBackdrop.style.display = isAnyMenuOpen ? 'block' : 'none';
    });
  });

  menuBackdrop.addEventListener('click', function () {
    document.querySelectorAll('.mega-menu').forEach(function (megaMenu) {
      megaMenu.removeAttribute('open');
    });
    menuBackdrop.style.display = 'none';
  });
});
